module.exports = __webpack_public_path__ + "static/media/dots.176c614d.png";